import React, { useEffect, useState } from "react";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import Dashboard from "../../pages/Dashboard/Dashboard";
import { GetLocalStorage, GetLocalStorageParsed } from "../../Utils/Utils";
import { useNavigate } from "react-router-dom";
import { userTransactionsListData } from "../../services/api/admin";
import { formatDateTime } from "../../Utils/common";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Transactions = () => {
  const { language, setLanguage } = useLanguage();
  const [transactionList, setTransactionList] = useState({});
  const token = GetLocalStorage("userInfo");
  const userDetail = GetLocalStorageParsed("userDetail");
  const navigate = useNavigate();

  const transactionStatusList = [
    { value: "1", label: "Success" },
    { value: "2", label: "Cancelled" },
    { value: "3", label: "Pending" }
  ];

   useEffect(() => {
      if (!token) {
        navigate("/");
      } else {
        getUserTransactionList();
      }
    }, []);
  
    const getUserTransactionList = async () => {
      try {
        const formData = new FormData();
        formData.append("user_id", userDetail?.id);
        const list = await userTransactionsListData(formData);
        setTransactionList(list?.data);
      } catch (err) {
      }
    };

    const generatePdf = async (reciptDetails) => {
      const hiddenDiv = document.createElement('div');
      hiddenDiv.style.position = 'fixed';
      hiddenDiv.style.top = '-10000px';
      hiddenDiv.style.left = '-10000px';
      hiddenDiv.style.width = '210mm';
      hiddenDiv.style.height = 'auto';

      hiddenDiv.innerHTML = `
          <div class="receipt-pdf-main-wrapper">
              <div class="receipt-pdf-wrapper">
                  <div class="receipt">
                      <header class="receipt__header">
                          <p class="receipt__title">
                              Payment Receipt
                          </p>
                          <p class="receipt__date">${formatDateTime(reciptDetails?.created_at)}</p>
                      </header>
                      <dl class="receipt__list">
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Name</dt>
                              <dd class="receipt__cost">${reciptDetails?.fullname}</dd>
                          </div>
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Email</dt>
                              <dd class="receipt__cost">${reciptDetails?.email}</dd>
                          </div>
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Mobile No.</dt>
                              <dd class="receipt__cost">${reciptDetails?.phone}</dd>
                          </div>
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Payment Id</dt>
                              <dd class="receipt__cost">${reciptDetails?.transaction_id}</dd>
                          </div>
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Paid On</dt>
                              <dd class="receipt__cost">${formatDateTime(reciptDetails?.created_at)}</dd>
                          </div>
                          <div class="receipt__list-row">
                              <dt class="receipt__item">Payment Method</dt>
                              <dd class="receipt__cost">${reciptDetails?.payment_method}<span>(${reciptDetails?.status})</span></dd>
                          </div>
                          <div class="receipt__list-row receipt__list-row--total">
                              <dt class="receipt__item">Total</dt>
                              <dd class="receipt__cost">₹ ${reciptDetails?.amount}</dd>
                          </div>
                      </dl>
                  </div>
              </div>
          </div>
        `;

      document.body.appendChild(hiddenDiv);

      try {
          // Add a small delay to ensure all elements and styles are loaded
          await new Promise(resolve => setTimeout(resolve, 100));

          const canvas = await html2canvas(hiddenDiv, { scale: 2 });
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210;
          const pageHeight = 295;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
          }

          pdf.save('payment-receipt.pdf');
      } catch (error) {
          console.error('Error generating PDF:', error);
      } finally {
          document.body.removeChild(hiddenDiv);
      }
  };

  return (
    <Dashboard
      first={language ? "होम" : "Home"}
      second={language ? "लेनदेन" : "Transactions"}
      head={language ? "लेनदेन" : "Transactions"}
    >
      <>
        <div className="aod-bottom">
          <div className="page_heading">
            <h5>{language ? "लेनदेन" : "Transactions"}</h5>
          </div>
          <div className="col-md-12">
            <div className="reciept-table table-responsive mt-2">
              <table
                className="table table mb-0 dataTable transaction_table"
                id="receipt_table"
                role="grid"
              >
                <thead className="">
                  <tr role="row">
                    <th>{language ? "क्रम संख्या" : "S.No"}</th>
                    <th>{language ? "आवेदन संख्या" : "Application Number"}</th>
                    <th>{language ? "लेनदेन आईडी" : "Transaction Id"}</th>
                    <th>{language ? "मात्रा" : "Amount"}</th>
                    <th>{language ? "भुगतान मोड" : "Payment Mode"}</th>
                    <th>{language ? "तारीख" : "Date"}</th>
                    <th>{language ? "स्थिति" : "Status"}</th>
                    <th>{language ? "देखना" : "View"}</th>
                  </tr>
                </thead>
                <tbody>
                {transactionList?.length > 0 ? (
                  transactionList?.map((item, index) => (
                    <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.application_number ? item?.application_number : "--"}</td>
                    <td>{item?.transaction_id ? item?.transaction_id : "--"}</td>
                    <td>{item?.amount ? item?.amount : "--"}</td>
                    <td>{item?.payment_mode ? item?.payment_mode : "--"}</td>
                    <td>{item?.created_at
                      ? formatDateTime(
                        item?.created_at
                      )
                    : "--"}</td>
                    <td>{item?.status ? item?.status : "--"}</td>
                    <td>
                      <button className="btn btn-green-view" onClick={() => { generatePdf(item) } }>{language ? "रसीद डाउनलोड करें" : "Download Recipt"}</button>
                    </td>
                  </tr>
                  ))
                ) : (
                  <></>
                )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    </Dashboard>
  );
};

export default Transactions;
